(ns frontend.ui.component.lp-portal.voima-components.card.view
  (:require
   [frontend.ui.component.lp-portal.voima-components.card.style :as style]
   [herb.core :refer [<class]]
   [reagent.core :as r]
   [common.util :as cu]
   [frontend.ui.style.theme.core :as theme]))

(defn- simple-body
  [{:keys [id] :as props} child]
  [:div
   {:class (<class style/simple-body props)
    :id    id}
   child])

(defn- split-body
  [main-child secondary-child split-left split-right props]
  [:div {:class (<class style/children-row)}
   [:div {:class (<class (partial style/main-child split-left props))}
    main-child]
   [:div {:class (<class (partial style/secondary-child split-right props))}
    secondary-child]])

(defn card
  [{:keys [title left-split right-split title-color] :as props} child right-child]
  [:div
   {:class (<class (partial style/card (cu/blank-value? title) props))}
   ;(when title
   [:div
    (merge {:class (<class (partial style/title props))}
           (when title-color
             {:style {:color title-color}}))
    title]
   ;)
   (if right-child
     [split-body child right-child (or left-split 8)
      (or right-split
          (when left-split
            (- 12 left-split))
          4) props]
     [simple-body props child])])

(defn expandable-card
  [_props]
  (let [expanded (r/atom false)]
    (fn [{:keys [_title _removed-since-empty? title-color expanded-title-color] :as props} child]
      (let [active-title-color (if @expanded
                                 (or expanded-title-color
                                     title-color)
                                 title-color)]
        [:div
         {:style (if @expanded
                   {:padding          "24px"
                    :position         "fixed"
                    :left             0
                    :top              0
                    :right            0
                    :bottom           0
                    :z-index          100000
                    :background-color (theme/color [:page-bg :bg])
                    :overflow         "auto"}
                   {:position         "relative"
                    :background-color "inherit"})}
         [card
          (assoc props :title-color active-title-color)
          [:div
           {:style (merge {:display :flex
                           :flex-direction :column
                           :gap "1rem"
                           :background-color "inherit"})}
           [:div
            {:style    (merge (if @expanded
                                {:position "absolute"
                                 :top      "36px"
                                 :right    "41px"
                                 :cursor   "pointer"}
                                {:position "absolute"
                                 :top      (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                                             "36px"
                                             "32px")
                                 :right    "18px"
                                 :cursor   "pointer"})
                              (when active-title-color
                                {:color active-title-color}))
             :on-click (fn [_exp]
                         (reset! expanded (not @expanded))
                         (deref expanded))}
            (if @expanded
              [:span "Collapse " [:i.fal.fa-compress-arrows-alt]]
              [:span "Expand " [:i.fal.fa-expand-arrows-alt]])]
           child]]]))))
